export const INTRO = 'intro';
export const QUESTION = 'question';
export const FEEDBACK = 'feedback';
